import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks/useToastError';
import { metricsKeys } from './metricsKeys';
import { EXPRESS_API } from 'configs/api/expressApi';

export type QueryParams = {
  from?: string;
  to?: string;
  users?: string;
  customer?: string;
};

interface AllReportDataResponse {
  data: {
    date: string;
    cnt: number;
  }[];
  report: string;
}

export const getAllReports = async (
  params: QueryParams
): Promise<AllReportDataResponse[]> => {
  return (
    await EXPRESS_API.get(`metrics/reports/data/all`, {
      params,
    })
  ).data;
};

export const useGetAllReportsQuery = (params: QueryParams) => {
  const { showError } = useToastError();
  return useQuery(
    metricsKeys.all_reports(params),
    () => getAllReports(params),
    {
      onError: showError,
      refetchOnMount: true,
    }
  );
};
